import { call, put, take, takeLatest } from "redux-saga/effects";
import CustomMessage from "../../components/common/Snackbar/Snackbar";
import { AUTH_TOKEN, USER_DATA } from "../../constants/localPath";
import { axiosInstance } from "../../network/apis";
import { VERIFY_OTP_URL, LOGIN_URL, AUTH_URL, UPDATE_AUTH_TOKEN, GET_DASHBOARD_CONFIG, GET_QUERY_EMPLOYEE_DETAILS, GET_MY_ACCESS } from "../../network/apis/apiPath";
import { HOME_PATH, LOGIN_PATH } from "../../utils/Constants";
import { getLocalStoreString, setLocalStore } from "../../utils/Helper";
import { AUTH_REQUEST, QUERY_EMPLOYEE_DETAILS, VERIFY_OTP } from "../type";
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import app from "../../configs/FirebaseConfig";
import axios from 'axios';
import clevertap from 'clevertap-web-sdk';
import { server } from "../../configs/AppConfig"
import { saveUserDetails, saveWriteServicesList } from "./authSlice";

const auth = getAuth(app);
const EmployeeID = getLocalStoreString('EmployeeID');

function* authWorker(action) {
  const { Payload, nextStep, setError, setErrorContent, enqueueSnackbar } = action;
  try {
    const response = (yield call(
      axiosInstance.get, `${LOGIN_URL}`, { params: Payload }));
    if (response.data.Status === 0) {
      setError(true)
      setErrorContent(response.data.Message);
    } else {
      nextStep && typeof nextStep === "function" && nextStep()
      setLocalStore('EmployeeID', response.data.Data);
    }
  } catch (error) {
    console.log('error', error);
  }
}

function* otpVerify(action) {
  const { Payload, setOtpError, enqueueSnackbar, navigate } = action;
  try {
    const response = (yield call(
      axiosInstance.post,
      VERIFY_OTP_URL,
      Payload
    ));
    if (response.data.Status === 0) {
      setOtpError(true)
    } else {
      console.log('response', response.data.Data);
      const idToken = response.data.Data.FirebaseToken;
      setLocalStore('CompanyID', response.data.Data.Employee.CompanyId);
      setLocalStore('FirstName', response.data.Data.Employee.FirstName);
      setLocalStore('LastName', response.data.Data.Employee.LastName);
      setLocalStore('Image', response.data.Data.Employee.Image);
      setLocalStore('EmployeeCode', response.data.Data.Employee.EmployeeCode);
      signInWithCustomToken(auth, idToken)
        .then(async (userCredential) => {
          const BearerToken = userCredential.user.accessToken;
          const RefreshToken = userCredential.user.refreshToken;
          const TimeToken = new Date();

          setLocalStore('RefreshTimestamp', TimeToken.toString());
          // refresh token
          setLocalStore('RefreshToken', RefreshToken.toString());
          // token timestamp
          setLocalStore('BearerToken', BearerToken.toString());
          setLocalStore('LoggedIn', JSON.stringify(true));
          axios.defaults.headers.common['Authorization'] = `Bearer ${BearerToken}`;
          axios.defaults.headers.common['Accept'] = 'application/json';
          axios.defaults.headers.common['Accrue-Client'] = 'AdminPanel';
          axios.defaults.headers.common['EmployeeID'] = EmployeeID;

          const Headers = {
            Authorization: `Bearer ${BearerToken}`,
            Accept: 'application/json',
            'Accrue-Client': 'AdminPanel',
            EmployeeID: EmployeeID
          };
          const contestResponse = await axios.get(`${GET_DASHBOARD_CONFIG}?employeeCode=${response.data.Data.Employee.EmployeeCode}`, { headers: { ...Headers, "Tenant-Id": response.data.Data.Employee.CompanyId } });
          const contestId = contestResponse?.data?.contests[0]?.contestId
          setLocalStore('configPermissionData', JSON.stringify(contestResponse.data))
          setLocalStore('ContestId', contestId);
          clevertap.onUserLogin.push({
            "Site": {
              "Name": response.data.Data.Employee.FirstName + ' ' + response.data.Data.Employee.LastName,
              "Identity": response.data.Data.Employee.EmployeeID,
              "Email": response.data.Data.Employee.EmailId,
              "Phone": response.data.Data.Employee.MobileNo,
              "Gender": response.data.Data.Employee.Gender,
              "DOB": response.data.Data.Employee.DateOfBirth,
              "Emp-Code": response.data.Data.Employee.EmployeeCode,
              "Emp-Id": response.data.Data.Employee.EmployeeID,
              "Company-Id": response.data.Data.Employee.CompanyId,
              "Company-Name": response.data.Data.Employee.CompanyName,
              "Department-Name": response.data.Data.Employee.DepartmentName,
              'Photo': response.data.Data.Employee.Image,
              "USER-TYPE": server == 'UAT' ? 'UAT User' : "PROD User",
            }
          })
          axios
            .get(
              `${UPDATE_AUTH_TOKEN}=${EmployeeID}`,
              { headers: Headers }
            ).then(response => {
              CustomMessage("Signin succesfully..", "success", enqueueSnackbar);
              setOtpError(false)
              window.location.href = HOME_PATH
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  } catch (error) {
    console.log(error);
  }
}

function* getQueryEmployeeDetails(action) {
  const { payload } = action
  try {
    const response = (yield call(axiosInstance.post, `${GET_QUERY_EMPLOYEE_DETAILS}`, payload));
    if (response.data) {
      localStorage.setItem('EmployeeId', response.data.Data.EmployeeID)
      localStorage.setItem('CompanyID', response.data.Data.CompanyId)
      setLocalStore('EmployeeId', response.data.Data.EmployeeID);
      setLocalStore('CompanyID', response.data.Data.CompanyId);
      setLocalStore('FirstName', response.data.Data.FirstName);
      setLocalStore('LastName', response.data.Data.LastName);
      setLocalStore('Image', response.data.Data.Image);
      setLocalStore('EmployeeCode', response.data.Data.EmployeeCode);
      yield put(saveUserDetails(response?.data?.Data))
      window.dispatchEvent(new Event("employeeDetailsFetch"));
      const Headers = {
        Authorization: `Bearer ${payload?.Token}`,
        Accept: 'application/json',
        'Accrue-Client': 'AdminPanel',
        EmployeeID: response.data.Data.EmployeeID,
      };

      const accessResponse = (yield call(axios.get, `${GET_MY_ACCESS}?EmployeeID=${response.data.Data.EmployeeID}`, { headers: { ...Headers, "Tenant-Id": response.data.Data.CompanyId } }))
      const access = accessResponse?.data.Data.AccessGranted;
      if (access) {
        localStorage.setItem('Permissions', JSON.stringify(access));

        const writeServices = access?.map((role) => {
          return role.Access.map((item) => {
            return item.Write === true && item.Service;
          }).filter((e) => e);
        });

        var writeServicesList;

        if (writeServices?.length === 1) {
          writeServicesList = writeServices[0];
        } else if (writeServices?.length === 2) {
          writeServicesList = [...writeServices[0], ...writeServices[1]];
        } else if (writeServices?.length === 3) {
          writeServicesList = [
            ...writeServices[0],
            ...writeServices[1],
            ...writeServices[2],
          ];
        }
        yield put(saveWriteServicesList(writeServicesList))
        localStorage.setItem('WriteServices', JSON.stringify(writeServicesList));
      }

      axios.get(`${GET_DASHBOARD_CONFIG}?employeeCode=${response.data.Data.EmployeeCode}`, { headers: { ...Headers, "Tenant-Id": response.data.Data.CompanyId } }).then((res) => {
        const contestId = res.data?.contests[0]?.contestId
        setLocalStore('configPermissionData', JSON.stringify(res))
        setLocalStore('ContestId', contestId);
        setLocalStore('LoggedIn', false)
        // location.href = location.origin + location.pathname + location.search
        // window.location.reload()
      })
    }
  } catch (error) {
    console.log(error);
  }
}


export function* authWatcher() {
  yield takeLatest(AUTH_REQUEST, authWorker);
  yield takeLatest(VERIFY_OTP, otpVerify)
  yield takeLatest(QUERY_EMPLOYEE_DETAILS, getQueryEmployeeDetails)
}


